import { render } from "./Events.vue?vue&type=template&id=2714a58f&scoped=true"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"

import "./Events.vue?vue&type=style&index=0&id=2714a58f&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3816345015/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2714a58f"]])

export default __exports__